import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Types
import { SignedKey } from "../types/signedKey";

// State
import { AppState } from "./store";

const initialState: { signedKey: SignedKey | null } = {
  signedKey: null,
};

export const signedKeyFormSlice = createSlice({
  name: "signedKey",
  initialState,
  reducers: {
    setSignedKey: (state, { payload }: PayloadAction<SignedKey | null>) => {
      state.signedKey = payload;
    },
  },
});

export const { setSignedKey } = signedKeyFormSlice.actions;

export const selectSignedKey = (state: AppState) => state.signedKey.signedKey;

export default signedKeyFormSlice.reducer;
